import React, { FC, useContext, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Button } from '../../common/components/Button'
import { ChatContext } from '../context/ChatContext'
import { CreateQuoteDialog } from '../../features/create-quote'
import { PreviewEditsContext } from '../../features/preview-edits/model/PreviewEditsContext'

export const ChatQuoteCreateButton: FC<{ className?: string }> = ({ className }) => {
  const { t } = useTranslation()
  const { chatId, preview } = useContext(ChatContext)
  const { dirty } = useContext(PreviewEditsContext)
  const [dialogOpened, setDialogOpened] = useState(false)

  return (
    <>
      <Button
        className={className}
        primary
        big
        disabled={!preview || dirty}
        onClick={() => setDialogOpened(true)}
      >
        {t('Create quote')}
      </Button>

      <CreateQuoteDialog opened={dialogOpened} onClose={() => setDialogOpened(false)} chatId={chatId} />
    </>
  )
}
